import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip scroll to top for catalog sub-navigation (handled by Catalogo.tsx transition)
    // Se stiamo navigando dentro /catalogo/categoria/... non scrollare in alto subito
    if (pathname.includes('/catalogo/categoria/')) {
      // Lasciamo che sia Catalogo.tsx a gestire lo scroll reset dopo l'animazione
      return;
    }

    // Per tutte le altre route, scroll immediato
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
